<template>
  <div class="gender_picker">
    <van-cell
      class="after_field_border"
      title="性别"
      is-link
      :value="sexFormat"
      @click="onShow"
    />
    <van-popup v-model="show" position="bottom">
      <van-picker
        show-toolbar
        :default-index="sex"
        :columns="columns"
        @cancel="onCancel"
        @confirm="onConfirm"
      />
    </van-popup>
  </div>
</template>

<script>
import { Cell, Picker, Popup } from 'vant'

export default {
  name: 'GenderPicker',
  model: {
    prop: 'value',
    event: 'confirm'
  },
  props: {
    value: {
      type: Number
    }
  },
  components: {
    [Cell.name]: Cell,
    [Picker.name]: Picker,
    [Popup.name]: Popup
  },
  data () {
    return {
      show: false,
      sexFormat: '',
      sex: 0,
      columns: ['保密', '男', '女'],
      columns1: [
        { label: '男', value: 1 },
        { label: '女', value: 2 }
      ]
    }
  },
  created () {
    this.sex = this.value
    this.showCellValue()
  },
  methods: {
    onShow () {
      this.show = true
    },
    onConfirm (value, index) {
      this.sex = index
      let sex = index
      this.showCellValue()
      this.$emit('confirm', sex)
      this.show = false
    },
    showCellValue () {
      if (this.sex === 1) {
        this.sexFormat = '男'
      } else if (this.sex === 2) {
        this.sexFormat = '女'
      } else {
        this.sexFormat = '保密'
      }
    },
    onCancel () {
      this.show = false
    }
  }
}
</script>

<style scoped lang="scss">
</style>
